"use client";
import { store } from "@/store";

const DEVICE_PREF_KEYS = new Set([
  "selectedInputDevice",
  "selectedOutputDevice",
]);

/**
 * Wipe every client-side cache that could leak state from a previous agency
 * or user. Call immediately before a hard navigation after login, logout,
 * agency switch, or agency creation. Server-side Next.js caches are busted
 * separately by revalidateAllAgencyCaches() in src/server/auth/actions.ts.
 */
export async function purgeClientCaches() {
  // Disconnect the chat socket explicitly so the server removes it right
  // away (no ~25s ping-timeout wait). Without this, the old socket lingers
  // with its stale agency context and keeps pushing unreadCounts during the
  // window between window.location.href and the new page's socket handshake.
  try {
    const { disconnectChatSocket } = await import("@/components/chat/hooks/useSocket");
    disconnectChatSocket();
  } catch (_) {}

  try {
    const persistor = (store as { __persistor?: { pause?: () => void; purge?: () => Promise<void> } }).__persistor;
    persistor?.pause?.();
    await persistor?.purge?.();
  } catch (e) {
    console.warn("[purgeClientCaches] persistor purge failed", e);
  }

  if (typeof window === "undefined") return;

  try {
    window.sessionStorage?.clear();
  } catch (_) {}

  try {
    const keep: Record<string, string> = {};
    for (const k of DEVICE_PREF_KEYS) {
      const v = window.localStorage.getItem(k);
      if (v !== null) keep[k] = v;
    }
    window.localStorage.clear();
    for (const [k, v] of Object.entries(keep)) {
      window.localStorage.setItem(k, v);
    }
  } catch (_) {}
}
